module.exports = __webpack_public_path__ + "img/1726043958631-screenshot-1726043941737.png.8afb27f3.webp";